export const initials = (...names: (string | null | undefined)[]) =>
  names.filter((val) => val).map((val) => val?.charAt(0))

export const fullName = (...names: (string | null | undefined)[]) =>
  names.filter((val) => val).join(' ')

export const capitalize = (str: string, keepCase?: boolean) =>
  `${str.charAt(0).toUpperCase()}${keepCase ? str.slice(1) : str.slice(1).toLowerCase()}`
